import Main from './Main.vue'

export default [{
  path: 'pregao/:id',
  name: 'pregao',
  component: Main
}
]



// WEBPACK FOOTER //
// ./src/app/website/pregao/routes.js